import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, s = /* @__PURE__ */ c("path", { d: "M22.47 9.09c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06A16.195 16.195 0 0 0 12 3.25c-4.36 0-8.45 1.7-11.53 4.78-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0C4.33 6.29 8.04 4.75 12 4.75c3.96 0 7.67 1.54 10.47 4.34ZM10.75 19.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Z" }, null, -1), n = /* @__PURE__ */ c("path", { d: "M19.42 12.86c-.19 0-.38-.07-.53-.22A9.692 9.692 0 0 0 12 9.78a9.65 9.65 0 0 0-6.89 2.86c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06C6.18 9.46 9 8.29 12.01 8.29s5.83 1.17 7.96 3.29c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22h-.02Zm-4.06 3.34c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06A6.21 6.21 0 0 0 12 13.31c-1.67 0-3.24.65-4.42 1.83-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0 .9-.9 2.09-1.39 3.36-1.39s2.46.49 3.36 1.39Z" }, null, -1), r = [
  s,
  n
];
function a(d, l) {
  return e(), t("svg", o, [...r]);
}
const h = { render: a };
export {
  h as default,
  a as render
};
